<template>
    <!--
        MUST be a real Vuetify layout item, not a plain <div>.

        This sits as a direct child of <v-layout> in Auth.vue, and .v-layout is
        `display: flex` - a flex ROW. Its siblings (v-app-bar, v-navigation-drawer,
        v-footer) are all layout items, which Vuetify takes out of flow and
        accounts for via --v-layout-top/left/right/bottom. A plain <div> is not:
        it stayed in the flex row and claimed its own intrinsic WIDTH beside
        v-main, pushing the whole page ~400px to the right - the width of
        "Attention: N device(s) expiring soon." plus "View Invoices".

        Because the bar only renders when needsAttention is true, this hit only
        accounts whose payment status is not 'good', on every page, which made it
        look account-specific rather than structural.

        v-system-bar registers via useLayoutItem at position 'top' with
        layoutSize = height, so it reserves 32px of VERTICAL space and v-main
        offsets itself. Nothing else has to know about it.
    -->
    <!--
        A non-owner cannot open /invoices - the router bounces them - so the bar
        is hidden from them ONCE THINGS ARE OVERDUE, where the reminder modal
        takes over with copy telling them to ask the owner. It stays visible for
        the earlier `warning` state, which the modal does not cover: that is the
        only app-wide notice a member gets before things go wrong, and losing it
        would be worse than a link they cannot follow.
    -->
    <v-system-bar
        v-if="subscriptionStore.needsAttention && (authStore.isCircleOwner || !subscriptionStore.isOverdue)"
        :color="subscriptionStore.statusColor"
        :height="32"
        class="payment-status-bar"
        @click="navigateTo('invoices')"
    >
        <v-icon size="16" color="white" class="me-2">mdi-alert-circle</v-icon>
        <span class="text-white text-body-2">{{ subscriptionStore.statusMessage }}</span>
        <template v-if="subscriptionStore.daysUntilSuspension !== null && subscriptionStore.daysUntilSuspension > 0">
            <v-chip size="x-small" color="white" variant="outlined" class="ms-2">
                {{ subscriptionStore.daysUntilSuspension }}d until suspension
            </v-chip>
        </template>
        <v-spacer/>
        <span class="text-white text-caption text-decoration-underline">View Invoices</span>
    </v-system-bar>
</template>

<script setup>
import {useAuthStore} from "@/stores/authStore";
import {useSubscriptionStore} from "@/stores/subscriptionStore";
import {useNavigation} from "@/composables/globals";

const authStore = useAuthStore();
const subscriptionStore = useSubscriptionStore();
const {navigateTo} = useNavigation();
</script>

<style scoped>
/* v-system-bar defaults to justify-content: flex-end / text-align: end, which
   would right-align the message. The original div read left-to-right with a
   spacer before "View Invoices", so restore that. */
.payment-status-bar {
    cursor: pointer;
    justify-content: flex-start;
    text-align: start;
}

.payment-status-bar:hover {
    filter: brightness(1.1);
}
</style>
